import React, { useState } from "react";
import { Layout } from "antd";
import {
  CREATOR_LINK,
  CREATOR_NAME,
  PROJECT_LINK,
  PROJECT_NAME,
} from "../../constants/constent";
import LS_SERVICE from "../../utils/localStorage";
import { Link } from "react-router-dom";

function LayoutFooter() {
  const { Footer } = Layout;
  const [companyName] = useState(PROJECT_NAME);
  const handleOpenLink = (LINK) => {
    window.open(LINK, "_blank", "noopener,noreferrer");
  };

  return (
    <Footer
      style={{
        textAlign: "center",
      }}
    >
      <Link
        onClick={() => {
          handleOpenLink(PROJECT_LINK);
        }}
        to="#"
      >
        {PROJECT_NAME}{" "}
      </Link>
      ©{new Date().getFullYear()} Powered by{" "}
      <Link
        style={{ color: "orange", fontWeight: "bold" }}
        onClick={() => {
          handleOpenLink(CREATOR_LINK);
        }}
        to="#"
      >
        {CREATOR_NAME}
      </Link>
    </Footer>
  );
}

export default LayoutFooter;
